import { html, nothing } from 'lit-html';

import more from '@disy/cadenza-icons/more.svg';
import { renderStyleClass } from '@disy/lib/add-style-class';
import { array } from '@disy/lib/array-util';
import type { ButtonSize } from '@disy/ui/button';
import { createIconButton } from '@disy/ui/button';
import { icon } from '@disy/ui/icon';
import { renderIcon } from '@disy/ui/icon';
import type { MenuContent } from '@disy/ui/menu';
import { menu } from '@disy/ui/menu';

import i18n from './more-actions-button.properties';

export function createMoreActionsButton(
  label: string,
  { size, styleClass }: { size?: ButtonSize; styleClass?: string | string[] } = {},
) {
  return createIconButton(icon(more), i18n('moreActions'), {
    variant: 'borderless',
    size,
    styleClass: [...array(styleClass), 'more-action', 'is-hover-visible'],
    attrs: {
      'aria-haspopup': 'menu',
      'aria-label': `${label} – ${i18n('moreActions')}`,
    },
  });
}

export function renderMoreActionsButton(
  label: string,
  {
    size,
    styleClass,
    menuContent,
  }: { size?: ButtonSize; styleClass?: string | string[]; menuContent?: MenuContent } = {},
) {
  const title = i18n('moreActions');
  return html`<button
    class="button button-icon button-${size} button-borderless more-action is-hover-visible ${renderStyleClass(
      styleClass,
    )}"
    type="button"
    title="${title}"
    aria-label="${label} - ${title}"
    aria-haspopup="menu"
    ${menuContent ? menu(menuContent) : nothing}
  >
    ${renderIcon(more)}
  </button>`;
}
